import { createSlice } from "@reduxjs/toolkit";
import { createEligibility, getEligibilityCategories } from "./thunk";

const initialState = {
  formData: {
    schoolName: "",
    email: "",
    mobile: null,
    classUpto: null,
    board: "",
    medium: "",
    noStudents: null,
    anySkillProgram: "1",
    skillProgramDetails: "",
    skillProgramIds:[],

  },
  categories: [],
  loading:false,
  error:"",
};

const eligibilitySlice = createSlice({
  name: "eligibilitySlice",
  initialState,
  reducers: {
    setFormData(state, action) {
      const { name, value } = action.payload;
      state.formData = { ...state.formData, [name]: value };
    },
    clearError: (state) => {
      state.error = null;
    },
  setskillProgramIds(state, action) {
  const id = action.payload;
  if (state.formData.skillProgramIds.includes(id)) {
    // remove if exists
    state.formData.skillProgramIds = state.formData.skillProgramIds.filter((item) => item !== id);
  } else {
    // add if not exists
    state.formData.skillProgramIds.push(id);
  }
}

  },
    extraReducers: (builder) => {
      builder
        .addCase(getEligibilityCategories.pending, (state) => {
          state.loading = true;
        })
        .addCase(getEligibilityCategories.fulfilled,(state,action)=>
        {
          state.loading=false;
          state.categories=action.payload;
        })
        .addCase(getEligibilityCategories.rejected,(state,action)=>
        {
          state.loading=false;
            //  state.error=action.payload;
        })
         .addCase(createEligibility.pending, (state) => {
          state.loading = true;
        })
        .addCase(createEligibility.fulfilled,(state,action)=>
        {
          state.loading=false;
          state.categories=action.payload;
        })
        .addCase(createEligibility.rejected,(state,action)=>
        {
          state.loading=false;
          state.error=action.payload;
        })
        
      }
        
});

export const { setFormData ,setskillProgramIds,clearError} = eligibilitySlice.actions;

export default eligibilitySlice.reducer;
